import React from "react";
import { ErrorBoundary } from "react-error-boundary";

const FallbackComponent = ({ error, resetErrorBoundary }) => (
  <div style={{ textAlign: "center", padding: "2rem" }}>
    <h1>Something went wrong!</h1>
    <p>{error.message}</p>
    <button onClick={resetErrorBoundary}>Try Again</button>
  </div>
);

const FunctionalErrorBoundary = ({ children }) => {
  const errorHandler = (error, info) => {
    console.error("Logging error:", error, info);
  };

  return (
    <ErrorBoundary
      FallbackComponent={FallbackComponent}
      onError={errorHandler}
    >
      {children}
    </ErrorBoundary>
  );
};

export default FunctionalErrorBoundary;
